(function() {
	'use strict';

	angular.module('smb-app')
		.directive('smbStatusConfig', StatusConfigDirective)
		.controller('smbStatusConfigController', [
			'gettextCatalog',
			'sbToastService',
			'smbStatusConfigDataStore',
			StatusConfigController
		]);

	var templateUrl = require('./statusConfig.template');
	function StatusConfigDirective() {
		return {
			restrict: 'E',
			controller: 'smbStatusConfigController',
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {
				contentStatuses: '=',
				todoStatuses: '=',
				onStatusChange: '&',
				readonly: '='
			}
		};
	}

	function StatusConfigController(gettextCatalog, sbToastService, smbStatusConfigDataStore) {
		var vm = this;

		vm.statusDS = smbStatusConfigDataStore;
		vm.existingStatuses = null;

		vm.checkExistingStatuses = checkExistingStatuses;

		vm.onAddContentStatus = onAddContentStatus;
		vm.onDeleteContentStatus = onDeleteContentStatus;
		vm.onAddToDoStatus = onAddToDoStatus;
		vm.onDeleteToDoStatus = onDeleteToDoStatus;

		function checkExistingChips(chip) {
			var g = vm.contentStatuses.find(function(g) { return g === chip; });
			if (!g) {
				g = vm.todoStatuses.find(function(g) { return g === chip; });
			}

			return g ? true : false;
		}

		function isReadOnly() {
			return !!vm.readonly;
		}

		function checkExistingStatuses(status) {
			if (vm.existingStatuses === null) {
				vm.existingStatuses = vm.contentStatuses.concat(vm.todoStatuses);
			}

			var exists = checkExistingChips(status);
			if (exists) {
				sbToastService.showSimple(gettextCatalog.getString('Status already exists!'));
				return null;
			}
			return status;
		}

		function onAddContentStatus(chip) {
			vm.onStatusChange();
			return chip;
		}

		function onAddToDoStatus(chip) {
			vm.onStatusChange();
			return chip;
		}

		function onDeleteContentStatus(chip) {
			vm.onStatusChange();
			return chip;
		}

		function onDeleteToDoStatus(chip) {
			vm.onStatusChange();
			return chip;
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/statusConfig/statusConfig.js
// module id = 96
// module chunks = 1